export default class ConditionPolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, action) {
        return this.gate.allow('edit', 'action', action);
    }

    read(user, condition, action) {
        return this.gate.allow('edit', 'action', action);
    }

    add(user, action) {
        return this.gate.allow('edit', 'action', action);
    }

    edit(user, condition, action) {
        return this.gate.allow('edit', 'action', action);
    }

    destroy(user, condition, action) {
        return this.gate.allow('edit', 'action', action);
    }

    restore(user, condition, action) {
        return this.gate.allow('edit', 'action', action);
    }
}
